import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import {
  IconCab,
  IconCommercialVehicle,
  IconCoupe,
  IconHatchback,
  IconMinivan,
  IconSedan,
  IconSmallCar,
  IconSuv,
  IconWagon,
  TextCallout1,
  TextCaption2,
} from 'blocket-ui'

const ItemsWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;

  a:first-child {
    margin-left: 0;
  }
  a:last-child {
    margin-right: 0;
  }
`
const CAR_ITEM_COLOR = {
  selected: {
    icon: '#FFF',
    text: '#FFF',
    background: '#4182c3',
  },
  notSelected: {
    icon: '#737171',
    text: '#363433',
    background: 'inherit',
  },
}

export const CarIconWrapper = styled.a`
  display: block;
  cursor: pointer;
  margin: 0 2px;
  text-align: center;
  background-color: ${({ selected }) =>
    selected ? CAR_ITEM_COLOR.selected.background : CAR_ITEM_COLOR.notSelected.background};
  color: ${({ selected }) =>
    selected ? CAR_ITEM_COLOR.selected.text : CAR_ITEM_COLOR.notSelected.text};

  box-sizing: border-box;
  padding: 4px;
  border-radius: 4px;
  width: 68px;
  height: 48px;
`

const _createCarIconComponent = (CarIcon) => {
  const CarIconComponent = ({ color }) => <CarIcon color={color} width={32} height={20} />

  CarIconComponent.propTypes = {
    color: PropTypes.string.isRequired,
  }

  return CarIconComponent
}

const queryKeyToIcon = {
  // Car icons
  ccca: _createCarIconComponent(IconCab),
  ccce: _createCarIconComponent(IconCoupe),
  ccco: _createCarIconComponent(IconWagon),
  cchb: _createCarIconComponent(IconHatchback),
  ccmp: _createCarIconComponent(IconMinivan),
  ccsc: _createCarIconComponent(IconSmallCar),
  ccsd: _createCarIconComponent(IconSedan),
  ccsu: _createCarIconComponent(IconSuv),
  cctr: _createCarIconComponent(IconCommercialVehicle),
}

export const CarChassis = ({ parameters, label, onChange, currentQuery }) => {
  return (
    <div>
      <TextCallout1>{label}</TextCallout1>
      <ItemsWrapper>
        {parameters.map(({ queryKey, label: itemLabel }) => {
          const handleClick = (e) => {
            onChange(e, queryKey, currentQuery[queryKey] ? '' : '1')
          }
          const selected = Boolean(currentQuery[queryKey])

          const textColor = selected
            ? CAR_ITEM_COLOR.selected.text
            : CAR_ITEM_COLOR.notSelected.text
          const QueryKeyIcon = queryKeyToIcon[queryKey]

          return (
            <CarIconWrapper selected={selected} key={queryKey} onClick={handleClick}>
              <QueryKeyIcon color={textColor} />
              <TextCaption2 style={{ color: textColor, lineHeight: '15px' }}>
                {itemLabel}
              </TextCaption2>
            </CarIconWrapper>
          )
        })}
      </ItemsWrapper>
    </div>
  )
}

CarChassis.propTypes = {
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      queryKey: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  currentQuery: PropTypes.object.isRequired,
}

export default CarChassis
